import React from "react";
import { useHistory } from "react-router-dom";
import ModalDisplay from "../Partials/ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { tenzero } from "../../constants/Constants";
import { Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/ErrorOutlineOutlined";

export default function QuitTestBox(props) {
  const history = useHistory();

  const user = props.user;

  function OkHandler() {
    history.push("/testdashboard", { user: user });
  }

  let displayValue = "none";
  if (props.display) displayValue = "block";

  return (
    <ModalDisplay display={displayValue}>
      <Div margin={tenzero}>
        <ErrorIcon style={{ fontSize: "2.5rem", color: "#00112e" }} />{" "}
        <Typography
          fontWeight={"bold"}
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.25rem", textAlign: "center" }}
        >
          Quit Test
        </Typography>
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          Are you sure you want to quit the test?
        </Text>
      </Div>
      <Div
        margin={tenzero}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <ModalButton onClick={props.handler}>Cancel</ModalButton>
        <ModalButton onClick={OkHandler}>Confirm</ModalButton>
      </Div>
    </ModalDisplay>
  );
}
